import { Clear, Search } from '@mui/icons-material';
import { ClassNameMap, IconButton, Input } from '@mui/material';
import { useState } from 'react';
import useStyles from './styles';

interface SearchBarProps {
  id: string;
  placeHolder?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  onClear?: () => void;
}

const SearchBar = ({
  id,
  placeHolder,
  defaultValue,
  onChange,
  onSearch,
  onClear,
}: SearchBarProps) => {
  const classes: ClassNameMap = useStyles();
  const [value, setValue] = useState<string>(defaultValue ?? '');

  const onTypeSearch = (e: any) => {
    if (e.code === 'Enter' && onSearch) {
      e.preventDefault();
      onSearch(value);
    }
  };

  return (
    <div className={classes.searchWrapper}>
      <Input
        className={classes.searchInput}
        value={value}
        onChange={e => {
          setValue(e.target.value);
          if (onChange) onChange(e.target.value);
        }}
        id={id}
        onKeyDown={onTypeSearch}
        placeholder={placeHolder}
      />

      {value && onClear ? (
        <IconButton
          size="small"
          onClick={() => {
            if (!value) return;
            onClear();
            setValue('');
          }}
        >
          <Clear />
        </IconButton>
      ) : null}

      {onSearch !== undefined && (
        <div className={classes.searchBtn} onClick={() => onSearch(value)}>
          <Search height={20} width={20} color={'primary'} />
        </div>
      )}
    </div>
  );
};

export default SearchBar;
